import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import CryptoJS from "crypto-js";

// ------------------ COMPONENTES DE BASE--------------------------
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { encryptor, getSymmetricKey } from "../../../Services/Crypto/Crypto";
import { toastShow } from "../../../Services/ToastService";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import Card from "../../../Components/Card/Card";
import ImagenCRUD from "../../../Components/Dialog/ImagenCRUD";
import { downloadFile, uploadHandlerFirma } from "../../../Services/ArchivosService";

// ------------------- CONSULTAS A LA API---------------------------
import { getUsuarios, getPassUser, getFirmasPersonales } from "../../../API/IT/Users/UserRequests";
import { getRoles } from "../../../API/IT/Roles/RolesRequests";
import { descargarFirma, eliminarFirma, mostrarFirma } from "../../../API/IT/Imagenes/ImagenesRequest";

// ------------------- COMPONENTES NECESARIOS---------------------------
import ModalEditarUsuario from "./ModalScreenUsuarios/ModalEditarUsuario";
import ModalEditarAccesosPermisos from "./ModalScreenUsuarios/ModalEditarAccesosPermisos";
import UsuariosCrud from "./ModalScreenUsuarios/UsuariosCrud";

import "./UsuariosStyles.scss";

export const UsuariosScreen = () => {
  
  const toast = useRef(null);
  const fileUpload = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const [hiddenPassword, setHiddenPassword] = useState(userAuth.AccessWeb?.split(',').map(e=> parseInt(e)).includes(47));


  // Variables de edicion
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [userEdit, setuserEdit] = useState(null);
  const [accessPermissionEdit, setaccessPermissionEdit] = useState(null);
  const [roles, setRoles] = useState([]);
  const [password, setPassword] = useState('');
  const [selected, setSelected] = useState([]);
  const [selectedFirma, setSelectedFirma] = useState([]);
  const [showDialogFirma, setShowDialogFirma] = useState(false);
  const [listadoArchivos, setListadoArchivos] = useState([]);
  const [showDialogEliminar, setShowDialogEliminar] = useState(false);
  const [eliminarFoto, setEliminarFoto ] = useState([]);
  const [imagenes, setImagenes] = useState([]);

  const getUsers = async () => {
    setLoading(true);
    setUsuarios([]);
    const r = await getRoles();
    setRoles(r);
    const u = await getUsuarios();
    setUsuarios(u);
    setLoading(false);
  };

  const getPassworduser = async (rowData) => {
    // console.log(rowData)
    try {
      const key = await getSymmetricKey();
        const keyEncryptada = await encryptor(JSON.stringify({ key: key.exportKey, IdUser: rowData.IdUser })
        );
        // console.log("Datos antes de enviar al servidor:", keyEncryptada.IdUser);
        const pass = await getPassUser(keyEncryptada);
        // console.log("Respuesta del servidor:", pass);
        var decrypted = CryptoJS.AES.decrypt(pass, key.exportKey).toString(
          CryptoJS.enc.Utf8
        );
        // console.log({decrypted})
        setPassword(decrypted);
        const text = document.createElement("textarea");
        text.value = decrypted;
        text.setAttribute("readonly", "");
        document.body.appendChild(text);
        text.select();
        document.execCommand("copy");
        document.body.removeChild(text);

        toastShow(toast, "success", "Contraseña copiada");

        setTimeout(() => {
          setPassword(null);
        }, 5 * 1000);
    } catch (error) {
        console.error("Error al obtener la contraseña del usuario:", error);
        // Maneja el error aquí, por ejemplo, mostrando un mensaje de error al usuario
    }
  };


  const subirFoto = async (e) => {
    if (imagenes?.img?.length > 0) {
      toastShow(toast, "error", 'Error', "Solo se permite subir 1 firma.");
      return;
    }
    const inputs = [
      {
        name: "IdRef",
        type: "text",
        value: selectedFirma?.IdUser,
      },
      {
        name: "Codigo",
        type: "text",
        value: selectedFirma.IdPersonal,
      },
    ];
    uploadHandlerFirma({ e, inputs, toast, ref: fileUpload, getImagenes });
    getImagenes();
  };

  const getImagenes = async () => {
    const i = await getFirmasPersonales(selectedFirma?.IdPersonal);
    if (i?.length > 0) {
      const imagenCorrespondiente = i.find((e) => e.startsWith(selectedFirma?.IdPersonal));
      imagenCorrespondiente ? setListadoArchivos([imagenCorrespondiente]) : setListadoArchivos([]);
      if (imagenCorrespondiente) {
        const a = await mostrarFirma(selectedFirma?.IdPersonal, imagenCorrespondiente);
        setImagenes({ Codigo: selectedFirma?.IdPersonal, img: [a] });
      } else {
        setImagenes([]);
      }
    }
  };

  const descargarFoto = async (nombre) => {
    const a = await descargarFirma(selectedFirma?.IdPersonal, nombre);
    downloadFile(a, nombre);
  };

  const eliminar = async () => {
    const a = await eliminarFirma(selectedFirma?.IdPersonal, eliminarFoto);
    toastShow(toast, "success", "Eliminada", "Imágen eliminada correctamente.");
    setListadoArchivos(listadoArchivos.filter((archivo) => archivo !== eliminarFoto));
    setShowDialogEliminar(false)
    setEliminarFoto([])
    setImagenes([])
  };

  const columns = [
    {
      header: "ID",
      headerEn:"ID",
      field: "IdUser",
      className: "Xsmall",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdUser){
          setuserEdit(data);
        }
      },
    },
    {
      header: "Código",
      headerEn:"Code",
      field: "IdPersonal",
      className: "Xsmall",
      Format: 'Modal',
      Sumary: "count",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdUser){
          setuserEdit(data);
        }
      },
    },
    {
      header: "Usuario",
      headerEn:"User",
      field: "Usuario",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdUser){
          setuserEdit(data);
        }
      },
    },
    {
      header: "Nombre",
      headerEn:"Name",
      field: "UserName",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdUser){
          setuserEdit(data);
        }
      },
    },
    {
      header: "Correo electrónico",
      headerEn:"E-mail",
      field: "Email",
      className: "large",
      flex: 1,
    },
    {
      header: "Rol",
      headerEn:"Role",
      field: "Rol",
      editable: true,
      value: "IdRol",
      label: "Rol",
      items: roles,
      Format: "AutoComplete",
      flex: 1,
    },
    {
      header: "Areas",
      headerEn:"Areas",
      field: "NombresAreas",
      label: "Areas",
      flex: 3,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",  
      filter: false,
      body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
    },
    {
      field: "IdUser",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdUser){
              setuserEdit(rowData);
            }
          },
        },
        {
          icon: "ri-user-settings-line",
          tooltip: "Permisos",
          tooltipOptions: {
            position: "left",
          },
          onClick: (rowData) => {
            if(rowData?.IdUser){
              setaccessPermissionEdit(rowData);
            }
          },
        },
        {
          icon: "ri-edit-2-line",
          tooltip: "Firma",
          tooltipOptions: {
            position: "left",
          },
          onClick: (rowData) => {
            if(rowData?.IdUser){
              setSelectedFirma(rowData)
              setShowDialogFirma(true)
            }
          },
        },

        hiddenPassword ? 
        {
          icon: "pi pi-lock",
          tooltip: password,
          tooltipOptions: {
            position: "left",
          },
          onClick: (rowData) => {
            if(rowData?.IdUser){
              getPassworduser(rowData);
            }
          },
        } : null ,
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: usuarios,
    loading: loading,
    showModal: ()=>{}
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "users", config.language));
    getUsers()
  }, []);
  
  useEffect(() => {
    if(showDialogFirma){
      console.log('gkyvkj');
      getImagenes()
    }
  }, [showDialogFirma]);
  
  return (
    <div className="usuarios__contenedor p-2">
      <ModalEditarUsuario
        getUsers={getUsers}
        userEdit={userEdit}
        setuserEdit={setuserEdit}
        modo={selected ? "Editar" : "Crear"}
        hiddenPassword={hiddenPassword}
      />

      <ModalEditarAccesosPermisos
        getUsers={getUsers}
        accessPermissionEdit={accessPermissionEdit}
        setaccessPermissionEdit={setaccessPermissionEdit}
      ></ModalEditarAccesosPermisos>

      <Toast position="bottom-right" ref={toast}></Toast>
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "users", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getUsers} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="pt-4" style={{ height: "89vh" }}>
            <AgGrid table={table} />
          </div>
        }
      ></Card>
      {showDialog && (
        <UsuariosCrud
          loading={loading}
          toastRef={toast}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          usuarios={selected}
          getUsers={getUsers}
          modo={selected ? "Editar" : "Crear"}
        />
      )}

      {showDialogFirma && (
        <ImagenCRUD
          fileUpload={fileUpload}
          showDialogFoto={showDialogFirma}
          setShowDialogFoto={setShowDialogFirma}
          getInfo={getUsers}
          selected={selectedFirma}
          setSelected={setSelectedFirma}
          subirArchivo={subirFoto}
          getArchivos={getImagenes}
          descargar={descargarFoto}
          eliminar={eliminar}
          showDialogEliminar={showDialogEliminar}
          setShowDialogEliminar={setShowDialogEliminar}
          setEliminarFoto={setEliminarFoto}
          loading={loading}
          imagenes={imagenes}
          listadoArchivos={listadoArchivos}
          title={`Agregar Firma -  ${selectedFirma?.UserName}`}
        />
      )}
    </div>
  );
};

export default UsuariosScreen;
